import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { PersonRole } from "@ha/data/basic";
import { BaseModalComponent } from "@ha/ui/common";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Actions, ofActionCompleted, Store } from "@ngxs/store";

import { PermitTeamActions } from "../../states/permit-team.action";


export interface ScanCardModalComponentDataBA {
    permitId: number;
    role: PersonRole;
    isPremium: boolean;
}

@UntilDestroy()
@Component({
    templateUrl: "scan-card-modal-ba.component.html",
    styleUrls: ["scan-card-modal-ba.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScanCardModalComponentBA extends BaseModalComponent implements OnInit {
    public data: ScanCardModalComponentDataBA;

    constructor(private store: Store, private actions$: Actions) {
        super();
    }

    public ngOnInit() {
        this.actions$.pipe(ofActionCompleted(PermitTeamActions.FindPersonBA), untilDestroyed(this)).subscribe(() => {
            this.closeModal();
        });
    }

    public scanCompleteHandler(cardGuid: string) {
        this.store.dispatch(new PermitTeamActions.FindPersonBA({ query: cardGuid, role: this.data.role, isPremium: this.data.isPremium }));
    }
}
